import * as Yup from "yup";
import { cepRequired, cpf, name } from "../YupSchema";
import { IPlans } from "../../../interfaces/Purchase";

export const validationBuyPlans = (cartProductsCount: number) =>
  Yup.object().shape({
    payment_owner: Yup.object().shape({
      name: name,
      document_nr: cpf,
      address: Yup.object().shape({
        zip_code: cepRequired,
        city: Yup.string().required("global.schemas.city.required"),
        state: Yup.string().required("global.schemas.state.required"),
        additional_details: Yup.string().nullable(),
        country: Yup.string().required("global.schemas.country.required"),
        number: Yup.string().required("global.schemas.number_cep.required"),
        street: Yup.string().required("global.schemas.street.required"),
        neighborhood: Yup.string().required(
          "global.schemas.neighborhood.required"
        ),
      }),
    }),

    payment_info: Yup.object().when(["plans"], {
      is: (plans: IPlans[] | undefined) =>
        Array.isArray(plans) && plans.every((plan) => !plan?.hasValue),
      then: (value) => value.nullable(),
      otherwise: (value) =>
        value.shape({
          issuer: Yup.string().required("global.schemas.issuer.required"),
          number: Yup.string().required("global.schemas.number_card.required"),
          name: Yup.string().required("global.schemas.name_card.required"),
          maturity: Yup.string().required("global.schemas.maturity.required"),
          cvv: Yup.number().required("global.schemas.cvv.required"),
        }),
    }),
    plans: Yup.array()
      .of(
        Yup.object().shape({
          plan_id: Yup.number().nullable(),
          product_id: Yup.number().nullable(),
          hasValue: Yup.boolean().nullable(),
        })
      )
      .test(
        "validate-cart-size",
        (value) =>
          value.length > 1
            ? "global.schemas.validate_cart_size.requireds"
            : "global.schemas.validate_cart_size.required",
        (value) => value && value.length === cartProductsCount
      ),
  });
